// extracted by mini-css-extract-plugin
export default {"DeviceCoverage__row":"DeviceCoverage_DeviceCoverage__row__952xM","DeviceCoverage__deviceContainer":"DeviceCoverage_DeviceCoverage__deviceContainer__HNPhB"};